import { ContentFormats } from '@emerald-works-nova/components'

/**
 * Resolves a `primaryType` pair against the shared content-type catalogue.
 *
 * Both halves can be absent from the catalogue: content carries whatever
 * `primaryType` was stored, while `ContentFormats` only knows what the bundled
 * version of the shared package shipped with. A sub-type added to the catalogue
 * after this app was last released — or one that was never added at all, as is
 * the case with `msb` — resolves to `undefined` here rather than throwing at the
 * call site.
 *
 * @param {string[]} primaryType `[format]` or `[format, subType]`
 * @returns {{format?: Object, type?: Object}} the catalogue entries, where found
 */
export const resolveContentType = (primaryType = []) => {
  const [formatName, typeName] = primaryType || []
  const format = ContentFormats.find(f => f.name === formatName)
  const type = typeName ? format?.types?.find(t => t.name === typeName) : undefined

  return { format, type }
}

/**
 * Human-readable label for a `primaryType`, preferring the sub-type over the
 * format so that, say, a podcast reads "Podcasts" rather than "Audio".
 *
 * Falls back through the format label and finally to the raw stored value, so an
 * unrecognised type still shows something meaningful instead of an empty cell.
 *
 * @param {string[]} primaryType `[format]` or `[format, subType]`
 * @returns {string}
 */
export const getContentTypeLabel = (primaryType = []) => {
  const { format, type } = resolveContentType(primaryType)

  return type?.label ?? format?.label ?? primaryType?.[0] ?? ''
}
